import React from 'react';
import { Countdown, Button, TrustBar } from './Shared';
import { Facebook, Instagram, Youtube } from 'lucide-react';
export function CtaAndFooter() {
  return <>
      {/* SECCIÓN 12: LOS DOS CAMINOS */}
      <section className="py-20 px-4 bg-white text-center" data-id="element-12" data-mp="32onkf2vm5o8y">
        <div className="max-w-3xl mx-auto" data-id="element-13" data-mp="32m1ef7odfgsu">
          <h2 className="text-3xl md:text-4xl font-display font-bold text-brand-deep mb-12" data-id="element-14" data-mp="36qheutf7tw0o">
            Hay dos caminos frente a vos ahora mismo.
          </h2>

          <div className="grid md:grid-cols-2 gap-8 mb-12 text-left" data-id="element-15" data-mp="38qyt7e9m7ve">
            <div className="bg-red-50 border border-red-100 p-8 rounded-3xl" data-id="element-16" data-mp="36mu4n8jl4u2">
              <h3 className="font-bold text-red-600 mb-4 text-xl" data-id="element-17" data-mp="3ldu5gwjvqrxx">
                El primero:
              </h3>
              <p className="text-brand-text font-medium leading-relaxed" data-id="element-18" data-mp="3qbly5sscmi36">
                El próximo domingo a la tarde, vas a estar otra vez frente a la
                computadora buscando material. Buscando fichas que no estén
                alineadas al EBI. Buscando rúbricas que no tengan los 4 niveles.
                Perdiendo horas que no vas a recuperar. Y si querías generar
                ingresos extra con tus horas libres, vas a seguir pensando en
                hacerlo sin el sistema que lo hace posible.
              </p>
            </div>

            <div className="bg-brand-lightBlue border border-brand-sky p-8 rounded-3xl" data-id="element-19" data-mp="3q8dgwylod2aa">
              <h3 className="font-bold text-brand-blue mb-4 text-xl" data-id="element-20" data-mp="828n46lrs59o">
                El segundo:
              </h3>
              <p className="text-brand-text font-medium leading-relaxed" data-id="element-21" data-mp="32vybgbc8o4g">
                Hoy descargás Aula de Éxitos. Esta tarde organizás todo el año.
                El próximo domingo mientras tus colegas planifican vos tomás
                mate con tu familia. Y si querés monetizar tu formación docente,
                tenés en tus manos las 1.600 actividades · las rúbricas · los
                registros de progreso y la guía completa para hacerlo desde hoy
                mismo.
              </p>
            </div>
          </div>

          <p className="text-xl font-bold text-brand-deep mb-2" data-id="element-22" data-mp="tt9y8bqxspv4">
            El material ya existe. El sistema ya está probado.
          </p>
          <p className="text-lg text-brand-text mb-2" data-id="element-23" data-mp="13t0sqdfhz4v7">
            Cientos de maestr@s uruguay@s que ya lo usan ya tomaron la decisión.
          </p>
          <p className="text-2xl font-display font-bold text-brand-orange" data-id="element-24" data-mp="18m3rr131n6is">
            Solo faltás vos tomar acción!
          </p>

          <a href="https://drive.google.com/file/d/1-Bmm00mboYlPa577IGqC73UKg7g1orqM/view?usp=drive_link" target="_blank" rel="noopener noreferrer" className="mt-6 inline-flex max-w-full items-center justify-center rounded-[1.75rem_1.1rem_1.75rem_1.1rem] border-2 border-brand-orange bg-orange-50 px-6 py-4 text-center font-display font-bold text-brand-orange shadow-sm transition-colors hover:bg-brand-orange hover:text-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-orange focus-visible:ring-offset-2" data-id="element-25" data-mp="1hk5yzyddevei">
            ✨ Conocé como trabajamos. Hace Clic y descarga una muestra gratis de planificaciones y actividades que ofrecemos.
          </a>
        </div>
      </section>

      {/* SECCIÓN 13: CTA FINAL */}
      <section className="py-16 px-4 bg-brand-deep text-center text-white relative overflow-hidden" data-id="element-26" data-mp="21nbjvjxne2h5">
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[500px] h-[300px] bg-brand-blue/40 rounded-full blur-[120px] pointer-events-none" data-id="element-27" data-mp="1wpa4b8zfklaf"></div>
        <div className="max-w-3xl mx-auto relative z-10" data-id="element-28" data-mp="2pbuuw7830tcx">
          <h2 className="text-3xl md:text-4xl font-display font-bold mb-8" data-id="element-29" data-mp="2pa9yec27j0cf">
            🟠 ELEGÍ TU AULA DE ÉXITOS AHORA
          </h2>

          <div className="bg-white/10 border border-white/15 rounded-2xl p-6 mb-8" data-id="element-30" data-mp="2feq57xf12frd">
            <Countdown data-id="element-31" data-mp="18y4ogtthpt04" />
            <p className="text-brand-sky font-medium mt-4" data-id="element-32" data-mp="18yef8jmd046v">
              Después vuelve a su precio real y no vuelve esta oferta.
            </p>
          </div>

          <div className="max-w-md mx-auto mb-8" data-id="element-33" data-mp="141e805drwve6">
            <Button className="py-5 text-xl" data-id="element-34" data-mp="2ruofp4u56hyd">
              ¡Obtener mi acceso inmediato con descuento AHORA!
            </Button>
            <div className="mt-6 text-brand-sky" data-id="element-35" data-mp="2wokci3yo5yry">
              <TrustBar tone="dark" data-id="element-36" data-mp="2ivue101yf1dy" />
            </div>
          </div>

          <div className="font-bold text-brand-orange" data-id="element-37" data-mp="2nu5ond02pfx8">
            +1000 docentes uruguayas ya confían
          </div>
        </div>
      </section>

      {/* SECCIÓN 14: CIERRE EMOCIONAL Y FOOTER */}
      <footer className="bg-[#0c0a09] text-gray-400 py-16 px-4 text-center border-t border-white/10" data-id="element-38" data-mp="3flbpjvnmbhnk">
        <div className="max-w-4xl mx-auto" data-id="element-39" data-mp="31lswma3docvu">
          <div className="mb-12 max-w-lg mx-auto" data-id="element-40" data-mp="31kr93656dxx8">
            <p className="text-lg text-gray-300 mb-6 leading-relaxed font-medium" data-id="element-41" data-mp="36kdlxeh3dc5i">
              Enseñar no debería costarte todos los domingos del año.
              <br data-id="element-42" data-mp="1q4svqq2yspq7" />
              <br data-id="element-43" data-mp="1q8gpnqcbne5g" />
              Tu formación no debería generar menos ingresos que un oficio sin
              título.
              <br data-id="element-44" data-mp="1nlxx4mng2f2v" />
              <br data-id="element-45" data-mp="1nlfxrh5hjkqq" />Y tu vocación no debería ser el motivo por el que nunca
              tenés tiempo libre.
            </p>
            <p className="text-xl text-white font-bold mb-6" data-id="element-46" data-mp="1im34oeo0thfp">
              Aula de Éxitos no cambia lo que sos.
              <br data-id="element-47" data-mp="1wm46bwc40sw8" />
              <span className="text-brand-orange" data-id="element-48" data-mp="1wk9tl5azs738">
                Cambia lo que podés hacer con lo que sos.
              </span>
            </p>
            <p className="text-lg text-brand-sky font-medium" data-id="element-49" data-mp="13x704rl6amju">
              El año resuelto.
              <br data-id="element-50" data-mp="zx68u6cz6gvd" />
              El negocio en tus manos.
              <br data-id="element-51" data-mp="zuk0i4i9fxc3" />
              La decisión es tuya.
            </p>
          </div>

          <div className="text-2xl font-bold text-white mb-2" data-id="element-52" data-mp="1dp30686tkmqp">
            🌟 Tu Fénix Digital
          </div>
          <p className="text-brand-orange font-bold text-sm tracking-widest uppercase mb-8" data-id="element-53" data-mp="18v8fp2je43qk">
            AULA DE ÉXITOS · Edición 2026
          </p>

          <div className="flex flex-col md:flex-row justify-center items-center gap-4 mb-8" data-id="element-54" data-mp="g7cmw8wxyvz2">
            <a href="#" className="hover:text-white transition-colors" data-id="element-55" data-mp="2gbf4be2bdmr2">
              www.tufenixdigital.store
            </a>
          </div>

          <div className="flex justify-center gap-6 mb-8" data-id="element-56" data-mp="2l7nese5kgrrw">
            <a href="https://www.facebook.com/people/Tu-Fenix-Digital/61590759474336/" target="_blank" rel="noopener noreferrer" aria-label="Seguir a Tu Fénix Digital en Facebook" className="hover:text-white transition-colors" data-id="element-57" data-mp="2q1huz7lyqom8">
              <Facebook className="w-6 h-6" data-id="element-58" data-mp="1xdm2kf3ffiv9" />
            </a>
            <a href="https://www.instagram.com/tufenixdigital_oficial/" target="_blank" rel="noopener noreferrer" aria-label="Seguir a Tu Fénix Digital en Instagram" className="hover:text-white transition-colors" data-id="element-59" data-mp="22a2qp9amlx8c">
              <Instagram className="w-6 h-6" data-id="element-60" data-mp="2bcbyvsif9eik" />
            </a>
            <a href="https://www.youtube.com/@TuFenixDigital" target="_blank" rel="noopener noreferrer" aria-label="Visitar el canal de Tu Fénix Digital en YouTube" className="hover:text-white transition-colors" data-id="element-61" data-mp="3ipe112xf9svo">
              <Youtube className="w-6 h-6" data-id="element-62" data-mp="1b3vuvbdl1adj" />
            </a>
            <a href="https://wa.me/59892165229?text=Hola,%20estuve%20viendo%20Aula%20de%20Éxitos%20y%20tengo%20algunas%20consultas%20antes%20de%20comprar." target="_blank" rel="noopener noreferrer" aria-label="Contactar por WhatsApp" className="hover:opacity-80 transition-opacity flex items-center justify-center" data-id="element-63" data-mp="1b5gpf0zwctbe">
              <img src="https://cdn.magicpatterns.com/uploads/uXn6AGGRg46UecbDPQ4AwC/icone-du-logo-whatsapp-gris.png" alt="WhatsApp" className="w-6 h-6 object-contain" data-id="element-64" data-mp="scuvim8jvctg" />
            </a>
          </div>

          <div className="text-sm" data-id="element-65" data-mp="jc6cte87ooa8">
            © 2026 Tu Fénix Digital — Todos los derechos reservados
          </div>
        </div>
      </footer>
    </>;
}